__turbopack_context__.v({
  "className": "onest_84f9892c-module__jH-6QG__className",
  "variable": "onest_84f9892c-module__jH-6QG__variable",
});
